import React, { Component } from "react";
import Core from "Core";
import moment from "moment";
import { observer, inject } from "mobx-react";
import { FormControl } from "react-bootstrap";

class LastUpdatedOn extends Component {
  render() {
    const { value, stores } = this.props;

    let formatedValue = "";
    if (value) {
      formatedValue = moment(this.LastUpdated).format("L LTS");
    }

    return (
      <Core.Components.FormGroups.LabelValuePair
        label={stores.ui.translate.LastUpdatedOn}
      >
        <FormControl.Static>{formatedValue}</FormControl.Static>
      </Core.Components.FormGroups.LabelValuePair>
    );
  }
}
export default inject("stores")(observer(LastUpdatedOn));



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/LastUpdatedOn.js